import React, { useState, useEffect } from "react";
import axios from "axios";
import SeleccionCadetesSecciones from "./SeleccionCadeteSecciones";
import SelectorSeccionConDNI from "./SelectorSeccionConDNI";

const SelectorCompaniaSeccion = () => {
  const [compania, setCompania] = useState("");
  const [seccion, setSeccion] = useState("");
  const [secciones, setSecciones] = useState([]);
  const [companias, setCompanias] = useState([]);
  const [sede, setSede] = useState("Rosario"); // Estado para sede
  const [promocion, setPromocion] = useState("2025-2026"); // Estado para promoción
  const [cadetes, setCadetes] = useState([]);
  const [genero, setGenero] = useState(""); // Estado para género

  const obtenerSecciones = async () => {
    try {
      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/devuelveSecciones"
      );
      const seccionesData = response.data || [];
      setSecciones(seccionesData);
//       console.log(seccionesData)

      let companiasFiltradas = seccionesData.reduce((acc, seccion) => {
        const companiaId = seccion.companiaId;
        if (sede === "Rosario" && (companiaId === 2 || companiaId === 3 || companiaId === 4)) {
          if (!acc.includes(companiaId)) {
            acc.push(companiaId);
          }
        } else if (sede === "Recreo" && (companiaId === 6 || companiaId === 7 || companiaId === 8)) {
          if (!acc.includes(companiaId)) {
            acc.push(companiaId);
          }
        }
        return acc;
      }, []);

      const companiasAgrupadas = companiasFiltradas.map((companiaId) => {
        const compania = seccionesData.find((seccion) => seccion.companiaId === companiaId);
        return compania ? compania.Compania.nombre : "";
      });

      setCompanias(companiasAgrupadas);
    } catch (error) {
      console.error("Error al obtener las secciones", error);
    }
  };

  const obtenerCadetes = async (selectedCompania, selectedGenero) => {
    try {
      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveCadetesPorSedePromocion", {
          "promocion": promocion,
          "sede": sede,
          "genero": genero
        }
      );
      const cadeteData = response.data || [];
      setCadetes(cadeteData);
//       console.log(cadeteData);
    } catch (error) {
      console.error("Error al obtener los cadetes", error);
    }
  };

  const handleCompaniaChange = (e) => {
    const selectedCompania = e.target.value;
    setCompania(selectedCompania);
    setSeccion(""); // Reseteamos la sección cuando se cambia la compañía

    // Set genero based on compania selected
    if (selectedCompania == "Tercer Compañia Rosario" || selectedCompania == "Tercer Compañia Recreo") {
      setGenero("Femenino");
    } else {
      setGenero("Masculino");
    }

    // Llamar a obtenerCadetes solo después de seleccionar la compañía y el género
    if (selectedCompania) {
      obtenerCadetes(selectedCompania, genero); // Se pasa la compañía y el género
    }
  };

  const handleSeccionChange = (e) => {
    const selectedSeccion = e.target.value;
    setSeccion(selectedSeccion);
    obtenerCadetes(compania, genero); // Se refresca la lista de cadetes cuando cambia la sección
  };

  const handleSedeChange = (newSede) => {
    setSede(newSede);
    obtenerSecciones(); // Refresca las secciones al cambiar la sede
  };

  const handlePromocionChange = (newPromocion) => {
    setPromocion(newPromocion);
    obtenerSecciones(); // Refresca las secciones al cambiar la promoción
  };

  const seccionesFiltradas = secciones
    .filter((seccion) => seccion.Compania.nombre === compania)
    .filter((seccion) => {
      if (promocion === "2024-2025") {
        return seccion.descripcion.includes("2do año");
      }
      if (promocion === "2025-2026") {
        return seccion.descripcion.includes("1er año");
      }
      return true;
    });

  useEffect(() => {
    obtenerSecciones();
  }, [sede, promocion]); // Solo vuelve a obtener las secciones cuando cambia la sede o promoción

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "20px" }}>
      <h4 style={{ textAlign: "center" }}>Gestion de Secciones para los cadetes ISeP </h4>
  
      <div style={{ width: "100%", display: "flex", flexWrap: "wrap", alignContent: "center", justifyContent: "center" }}>
        <button
          style={{
            backgroundColor: sede === "Rosario" ? "#007bff" : "transparent",
            color: sede === "Rosario" ? "white" : "black",
            border: "1px solid #007bff",
            padding: "10px 20px",
            margin: "5px",
          }}
          onClick={() => handleSedeChange("Rosario")}
        >
          Rosario
        </button>
        <button
          style={{
            backgroundColor: sede === "Recreo" ? "#007bff" : "transparent",
            color: sede === "Recreo" ? "white" : "black",
            border: "1px solid #007bff",
            padding: "10px 20px",
            margin: "5px",
          }}
          onClick={() => handleSedeChange("Recreo")}
        >
          Recreo
        </button>
      </div>

      <div style={{ width: "100%", display: "flex", flexWrap: "wrap", alignContent: "center", justifyContent: "center" }}>
        <button
          style={{
            backgroundColor: promocion === "2025-2026" ? "#007bff" : "transparent",
            color: promocion === "2025-2026" ? "white" : "black",
            border: "1px solid #007bff",
            padding: "10px 20px",
            margin: "5px",
          }}
          onClick={() => handlePromocionChange("2025-2026")}
        >
          2025-2026
        </button>
        <button
          style={{
            backgroundColor: promocion === "2026-2027" ? "#007bff" : "transparent",
            color: promocion === "2026-2027" ? "white" : "black",
            border: "1px solid #007bff",
            padding: "10px 20px",
            margin: "5px",
          }}
          onClick={() => handlePromocionChange("2026-2027")}
        >
          2026-2027
        </button>
      </div>

      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div style={{ width: "400px", textAlign: "center" }}>
          <select value={compania} onChange={handleCompaniaChange}>
            <option value="">Selecciona una Compañía</option>
            {companias.map((comp, index) => (
              <option key={index} value={comp}>
                {comp}
              </option>
            ))}
          </select>

          {compania && (
            <>
              <select value={seccion} onChange={handleSeccionChange}>
                <option value="">Selecciona una Sección</option>
                {seccionesFiltradas.map((seccion) => (
                  <option key={seccion.id} value={seccion.id}>
                    {seccion.nombre} {seccion.descripcion}
                  </option>
                ))}
              </select>
            </>
          )}
        </div>
      </div>
      <h4>{seccion}</h4>
      <h4>Género: {genero}</h4> {/* Mostrar el género */}
      <h4>{compania}</h4>
    
      {cadetes && (
        <SeleccionCadetesSecciones cadetes={cadetes} finalizo={() => setCadetes(null)} seccionId={seccion} />
      )}

     
    </div>
  );
};

export default SelectorCompaniaSeccion;
